import { Price } from '@/features/graphql/generated/graphql'
import currencyJs from 'currency.js'

export const calculateTotalPriceFromUnitPrice = (price: Price, quantity: number): Price => {
    const totalPrice = currencyJs(price.amount).multiply(quantity)

    return {
        amount: totalPrice.toString(),
        currency: price.currency,
    }
}
